import { obterPedidosAvulsoAsync } from "../../services/pedidoAvulsoService";

const atualizarPedidosAvulso = async ({ commit }) => {
    const pedidosAvulso = await obterPedidosAvulsoAsync();
    commit('atualizarPedidosAvulso', pedidosAvulso);
}

const atualizarPedidoAvulso = ({ commit }, pedidoAvulso) => {
    commit('atualizarPedidoAvulso', pedidoAvulso);
}

const updatePedidoAvulso = ({ commit }, pedidoAvulso) => {
    commit('updatePedidoAvulso', pedidoAvulso);
}

export default {
    atualizarPedidosAvulso,
    atualizarPedidoAvulso,
    updatePedidoAvulso
}